<div class="employer-login-view">
    <div class="login-container">
        <div class="left-section">
            <div class="heading">Hey, Hello 👋 </div>
            <mat-tab-group headerPosition="below" animationDuration="1000ms" dynamicHeight [selectedIndex]="selectedTab"
                (selectedIndexChange)="onTabChange($event)">
                <mat-tab label="Login">
                    <app-login #loginCmp [isAdminExists]="adminExists" [existingAdminEmail]="existingAdminEmail"
                        (loginSubmit)="loginSumbit($event)" (gotoRegisterTab)="changeTab(1)"></app-login>
                </mat-tab>
                <mat-tab label="Register">
                    <app-register #registerCmp (register)="onRegister($event)"
                        (gotoLoginTab)="changeTab(0)"></app-register>
                </mat-tab>
            </mat-tab-group>
        </div>
        <div class="right-section">
            <img src="../../../assets/login.svg" alt="login image" />
        </div>
    </div>
</div>